<template>
  <div class="flex items-baseline">
    <div v-if="symbolBefore" class="mr-2">€</div>
    <div v-if="smallerDecimals" class="flex items-baseline">
      <span>{{ parts[0] }}</span>
      <span class="text-sm" v-if="parts[1]">,{{ parts[1] }}</span>
    </div>
    <div v-else>{{ formattedValue }}</div>

    <div v-if="!symbolBefore" :class="[smallerDecimals ? 'text-sm ml-1' : 'ml-2']">€</div>
  </div>
</template>

<script>
export default {
  name: 'EuroValue',

  props: {
    value: [Number, String],
    smallerDecimals: Boolean,
    symbolBefore: Boolean,
    hideDecimalsIfZero: Boolean
  },

  computed: {
    formattedValue() {
      let val = new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' })
        .format(this.value)
        .replace('€', '')
        .trim();

      if (this.hideDecimalsIfZero) {
        val = val.replace(',00', '');
      }

      return val;
    },

    parts() {
      const parts = this.formattedValue.split(',');
      return parts;
    }
  }
};
</script>

<style lang="css" scoped></style>
